import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['spinner', 'content']

  declare readonly spinnerTarget: HTMLElement
  declare readonly contentTarget: HTMLElement
  declare readonly hasContentTarget: boolean
  declare readonly hasSpinnerTarget: boolean

  onSubmit (event: Event): void {
    const form = event.target as HTMLFormElement
    if (form.id !== 'edit-ac-form') return

    if (this.hasSpinnerTarget) {
      this.showSpinner()
    }
  }

  showSpinner (): void {
    this.spinnerTarget.classList.remove('hidden')
    if (this.hasContentTarget) {
      this.contentTarget.classList.add('hidden')
    }
  }

  hideSpinner (): void {
    this.spinnerTarget.classList.add('hidden')
    if (this.hasContentTarget) {
      this.contentTarget.classList.remove('hidden')
    }
  }
}
